<template>
  <Can action="store" subject="billing">
    <div data-component-group="billing-dialog" data-component="add-new">
      <dialog-add
        icon="credit_card"
        :title="$t('create_dialog')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-billing-add-new
            :billing-item="{}"
            class="elevation-1"
            :is-loading="isAddingAccount"
            :is-on="true"
            :on-cancel="onCancel"
            :on-submit="createAccount"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isAddingAccount: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'billing', query: this.$route.query });
      },
      createAccount(item) {
        this.isAddingAccount = true;

        return this.$store
          .dispatch('billing/create', item)
          .then(() => {
            this.$emit('saved');
            this.$router.push({ name: 'billing', query: this.$route.query });
          })
          .catch(() => {
            return Promise.reject();
          })
          .finally(() => {
            this.isAddingAccount = false;
          });
      },
    },
  };
</script>
